import * as classnames from 'classnames';
import * as React from 'react';

import { IRouterSlot } from '../../../types/store/routerData';
import { ISlotItem, ISlotItemPort, ISlotItemSupply } from '../../../types/store/slotsItems';

export interface IImgSlotItemProps {
  onClick?: (routerSlotClickedElement: IRouterSlot, slotItemClickedElement: ISlotItem) => void;
  slotItem: ISlotItemPort | ISlotItemSupply | undefined;
  routerSlot: IRouterSlot;
  iconAdd?: string;
  iconEdit?: string;
}
const ImgSlotItem: React.SFC<IImgSlotItemProps> = props => {
  const style = props.slotItem && {
    backgroundImage: `url(${props.slotItem.imageFrontUrl})`
  };

  const slotClass = classnames('slot', { 'slot-filled': props.slotItem !== undefined });

  const iconClass = classnames(
    'fas hidePDF',
    {
      'fa-plus-circle': !props.iconAdd && props.slotItem === undefined,
      'fa-edit': !props.iconEdit && props.slotItem !== undefined
    },
    props.iconAdd && props.slotItem === undefined && props.iconAdd,
    props.iconEdit && props.slotItem !== undefined && props.iconEdit
  );
  return (
    <div className={slotClass} style={style}>
      {props.onClick && (
        <button
          className="add-port d-none d-md-block"
          onClick={props.onClick.bind(undefined, props.routerSlot, props.slotItem)}
        >
          <i className={iconClass} />
        </button>
      )}
    </div>
  );
};

export default ImgSlotItem;



// WEBPACK FOOTER //
// ./src/components/Configurator/ModalConfigurator/ImgSlotItem.tsx